export default __webpack_public_path__ + "a6202c6383251344f96845033749dc4a.png";